import type { FrontendLocaleData } from "@hakit/core";

export function DummyComponentReturn(props: Partial<FrontendLocaleData>) {
  return props;
}
